(() => {
  'use strict';
  const overlay = document.getElementById('LootProductTransition');
  if (!overlay) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  let navigating = false;

  function reset() {
    navigating = false;
    overlay.classList.remove('is-active');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('loot-transitioning');
  }

  function shouldSkipAnimation() {
    return reduceMotion.matches || connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '');
  }

  function eligible(link, event) {
    if (!link || event.defaultPrevented || navigating || shouldSkipAnimation()) return false;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (link.hasAttribute('download') || link.target === '_blank') return false;
    if (link.closest('quick-add-modal,modal-opener,product-form,.quick-add,.shopify-payment-button')) return false;
    try {
      const url = new URL(link.href, window.location.href);
      return url.origin === window.location.origin && /\/products\//.test(url.pathname);
    } catch {
      return false;
    }
  }

  document.addEventListener('click', (event) => {
    if (window.Shopify?.designMode) return;
    const link = event.target.closest('a[href]');
    if (!eligible(link, event)) return;
    event.preventDefault();
    navigating = true;
    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('loot-transitioning');
    window.setTimeout(() => window.location.assign(link.href), 500);
  }, true);

  window.addEventListener('pageshow', reset);
  window.addEventListener('pagehide', () => document.body.classList.remove('loot-transitioning'));
})();
